import { createAsyncThunk } from "@reduxjs/toolkit";
import { logout } from "./LoginSlice";
import { logoutUser } from "./AccountLogoutThunk";

/**
 * fetch all Vendorsonhome entries
 */
export const fetchVendorsonhomeItems = createAsyncThunk(
  "vendorsonhome/fetchItems",
  async (_, thunkAPI) => {
    const res = await fetch(
      `${process.env.REACT_APP_API_URL}/api/vendorsonhome`,
      {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "x-user-role": "admin",
        },
      }
    );
    if (res.status === 401) {
      thunkAPI.dispatch(logout());
      thunkAPI.dispatch(logoutUser());
      window.location.href = "/";
      return thunkAPI.rejectWithValue("Unauthorized");
    }
    const json = await res.json();
    if (!res) {
      throw new Error(json?.message || "Fetch failed");
    }
    return json;
  }
);

export const addVendorsonhomeItems = createAsyncThunk(
  "vendorsonhome/fetchItems",
  async (data, thunkAPI) => {
    const body = JSON.stringify(data);
    const res = await fetch(
      `${process.env.REACT_APP_API_URL}/api/vendorsonhome`,
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "x-user-role": "admin",
        },
        body: body,
      }
    );
    if (res.status === 401) {
      thunkAPI.dispatch(logout());
      thunkAPI.dispatch(logoutUser());
      window.location.href = "/";
      return thunkAPI.rejectWithValue("Unauthorized");
    }
    const json = await res.json();
    if (!res) {
      throw new Error(json?.message || "Fetch failed");
    }
    return json;
  }
);

export const addVendorsonhome = createAsyncThunk(
  "vendorsonhome/addItems",
  async (data, thunkAPI) => {
    const body = JSON.stringify(data);
    const res = await fetch(`${process.env.REACT_APP_API_URL}/api/vendor`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "x-user-role": "admin",
      },
      body: body,
    });
    if (res.status === 401) {
      thunkAPI.dispatch(logout());
      thunkAPI.dispatch(logoutUser());
      window.location.href = "/";
      return thunkAPI.rejectWithValue("Unauthorized");
    }
    const json = await res.json();
    if (!res) {
      throw new Error(json?.message || "Fetch failed");
    }
    return json;
  }
);

export const updateVendorsonhome = createAsyncThunk(
  "vendorsonhome/updateItems",
  async (data, thunkAPI) => {
    const body = JSON.stringify(data);
    const res = await fetch(
      `${process.env.REACT_APP_API_URL}/api/vendor?_id=${data._id}`,
      {
        method: "PUT",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "x-user-role": "admin",
        },
        body: body,
      }
    );
    if (res.status === 401) {
      thunkAPI.dispatch(logout());
      thunkAPI.dispatch(logoutUser());
      window.location.href = "/";
      return thunkAPI.rejectWithValue("Unauthorized");
    }
    const json = await res.json();
    if (!res) {
      throw new Error(json?.message || "Fetch failed");
    }
    return json;
  }
);

export const updateVendorsonhomeItems = createAsyncThunk(
  "vendorsonhome/updateHomeItems",
  async (data, thunkAPI) => {
    const body = JSON.stringify(data);
    const res = await fetch(
      `${process.env.REACT_APP_API_URL}/api/vendorsonhome?_id=${data._id}`,
      {
        method: "PUT",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "x-user-role": "admin",
        },
        body: body,
      }
    );
    if (res.status === 401) {
      thunkAPI.dispatch(logout());
      thunkAPI.dispatch(logoutUser());
      window.location.href = "/";
      return thunkAPI.rejectWithValue("Unauthorized");
    }
    const json = await res.json();
    if (!res) {
      throw new Error(json?.message || "Fetch failed");
    }
    return json;
  }
);

export const deleteVendorsOnHome = createAsyncThunk(
  "faqs/historydelete",
  async (data, thunkAPI) => {
    const res = await fetch(
      `${process.env.REACT_APP_API_URL}/api/vendorsonhome?_id=${data._id}`,
      {
        method: "DELETE",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "x-user-role": "admin",
        },
      }
    );
    if (res.status === 401) {
      thunkAPI.dispatch(logout());
      thunkAPI.dispatch(logoutUser());
      window.location.href = "/";
      return thunkAPI.rejectWithValue("Unauthorized");
    }
    const json = await res.json();
    if (!res) {
      throw new Error(json?.message || "Fetch failed");
    }
    return json;
  }
);

export const uploadImage = createAsyncThunk(
  "vendorsonhome/uploadImage",
  async (data) => {
    const formData = new FormData();
    formData.append("file", data);
    const res = await fetch(`${process.env.REACT_APP_API_URL}/api/upload`, {
      method: "POST",
      credentials: "include",
      headers: {
        "x-user-role": "admin",
      },
      body: formData,
    });
    const json = await res.json();
    if (!res) {
      throw new Error(json?.message || "Fetch failed");
    }
    return json;
  }
);

export const sendVendorsEmail = createAsyncThunk(
  "vendorsonhome/addItems",
  async (data, thunkAPI) => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/vendor/resend-password-setup-email`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            "x-user-role": "admin",
          },
          body: JSON.stringify(data),
        }
      );

      // Handle unauthorized separately
      if (res.status === 401) {
        thunkAPI.dispatch(logout());
        thunkAPI.dispatch(logoutUser());
        window.location.href = "/";
        return thunkAPI.rejectWithValue("Unauthorized");
      }

      const json = await res.json();
      
      if (!res.ok) {
        return thunkAPI.rejectWithValue(json?.message || "Request failed");
      }

      // ✅ Success
      return json;
    } catch (error) {
      // Network or unexpected error
      return thunkAPI.rejectWithValue(error.message || "Network error");
    }
  }
);
